var _rect, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2_8258)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#0A7CC1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "url(#paint1_linear_2_8258)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7029 20V18.575L15.1229 14.93C15.5829 14.43 15.9129 13.99 16.1129 13.61C16.3129 13.22 16.4129 12.825 16.4129 12.425C16.4129 11.405 15.7979 10.895 14.5679 10.895C13.6079 10.895 12.7229 11.255 11.9129 11.975L11.2679 10.535C11.6879 10.155 12.2129 9.85 12.8429 9.62C13.4729 9.39 14.1279 9.275 14.8079 9.275C15.9379 9.275 16.8029 9.53 17.4029 10.04C18.0129 10.55 18.3179 11.28 18.3179 12.23C18.3179 12.87 18.1629 13.485 17.8529 14.075C17.5529 14.665 17.0779 15.3 16.4279 15.98L14.1029 18.41H18.7229V20H11.7029Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_8258",
    x1: 26.7,
    y1: 0.00000243427,
    x2: 2.02053,
    y2: 7.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7566E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_8258",
    x1: 6.3,
    y1: -1.67856e-8,
    x2: 3.34629,
    y2: 28.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoAdult);
export default __webpack_public_path__ + "static/media/two-adult.4bd9b13d2c23fb6c2fe43dfc2bf1f47b.svg";
export { ForwardRef as ReactComponent };